import { Component, Input } from '@angular/core';

@Component({
  selector: 'evrideo-zoom-out-icon',
  templateUrl: './zoom-out-icon.component.html',
  styleUrls: ['./zoom-out-icon.component.scss'],
})
export class ZoomOutIconComponent {
  @Input()
  overrideStyle: Record<string, string> = {};
}
